import { useQuery } from '@tanstack/react-query'
import { canCreatePartyInNation, partyKeys } from '@/services/parties'

export function useCanCreateParty(nationId: string | undefined) {
  const canCreateQuery = useQuery({
    queryKey: partyKeys.canCreate(nationId!),
    queryFn: () => canCreatePartyInNation(nationId!),
    enabled: !!nationId,
  })

  return {
    canCreate: canCreateQuery.data,
    isLoading: canCreateQuery.isLoading,
    error: canCreateQuery.error,
  }
}
